document.querySelectorAll('.block-media-library').forEach(mediaLibrary => {

  // Filter buttons
  const filterButtons = mediaLibrary.querySelectorAll('.filter-links button');

  // Accordion items
  const accordionItems = mediaLibrary.querySelectorAll('.accordion__item');

  filterButtons.forEach(button => {

    button.addEventListener('click', () => {

      // Remove 'active' class from all buttons
      filterButtons.forEach(btn => {
        btn.classList.remove('button--primary');
        btn.classList.add('button--secondary');
      });

      // Add 'active'
      button.classList.add('button--primary');
      button.classList.remove('button--secondary');

      const filterValue = button.getAttribute('data-filter').replace('.', ''); // Remove the dot from the class selector
      accordionItems.forEach(item => {
        const downloadItems = item.querySelectorAll('.download-list__item');
        let hasVisibleItem = false;
        downloadItems.forEach(downloadItem => {
          if (filterValue === '*' || downloadItem.classList.contains(filterValue)) {
            downloadItem.style.display = 'block'; // Show item
            hasVisibleItem = true; // Mark visible item
          } else {
            downloadItem.style.display = 'none'; // Hide item
          }
        });
        // Show or hide the entire accordion
        if (hasVisibleItem) {
          item.style.display = ''; // Show accordion item
        } else {
          item.style.display = 'none'; // Hide accordion item
        }
      });

    });
  });

  const allMediaButton = mediaLibrary.querySelector('.filter-links button[data-filter="*"]');
  if (allMediaButton) {
    allMediaButton.click();
  }
});
